import Vue from 'vue'
import Router from 'vue-router'

// 路由定义改为动态 import，避免 20+ 个子模块打入主包；仅保留路由配置的懒加载
const routeModuleLoaders = [
  () => import(/* webpackChunkName: "route-index" */ './router-child/index'),
  () => import(/* webpackChunkName: "route-activity-short" */ './router-child/activity-short'),
  () => import(/* webpackChunkName: "route-dome" */ './router-child/dome'),
  () => import(/* webpackChunkName: "route-enterInfo" */ './router-child/enterInfo'),
  () => import(/* webpackChunkName: "route-personal-center" */ './router-child/personal-center'),
  () => import(/* webpackChunkName: "route-task-list" */ './router-child/task-list'),
  () => import(/* webpackChunkName: "route-orderAbout" */ './router-child/orderAbout'),
  () => import(/* webpackChunkName: "route-team" */ './router-child/team'),
  () => import(/* webpackChunkName: "route-planet" */ './router-child/planet'),
  () => import(/* webpackChunkName: "route-bloom-test" */ './router-child/bloom-test'),
  () => import(/* webpackChunkName: "route-bloom-proctor" */ './router-child/bloom-proctor'),
  () => import(/* webpackChunkName: "route-wonderful-moment" */ './router-child/wonderful-moment'),
  () => import(/* webpackChunkName: "route-super-quiz" */ './router-child/super-quiz'),
  () => import(/* webpackChunkName: "route-thirdpart" */ './router-child/thirdpart'),
  () => import(/* webpackChunkName: "route-wechat" */ './router-child/wechat'),
  () => import(/* webpackChunkName: "route-bloom-live" */ './router-child/bloom-live'),
  () => import(/* webpackChunkName: "route-event-plaza" */ './router-child/event-plaza'),
  () => import(/* webpackChunkName: "route-society" */ './router-child/society'),
  () => import(/* webpackChunkName: "route-discover" */ './router-child/discover'),
  () => import(/* webpackChunkName: "route-studentCertification" */ './router-child/sub-task/studentCertification'),
  () => import(/* webpackChunkName: "route-advertisement" */ './router-child/advertisement'),
  () => import(/* webpackChunkName: "route-questionnaire" */ './router-child/questionnaire'),
  () => import(/* webpackChunkName: "route-bloom-room" */ './router-child/bloom-room'),
  () => import(/* webpackChunkName: "route-battleCenter" */ './router-child/battleCenter'),
  () => import(/* webpackChunkName: "route-newTaskList" */ './router-child/newTaskList'),
  () => import(/* webpackChunkName: "route-unsubscribe" */ './router-child/unsubscribe'),
  () => import(/* webpackChunkName: "route-not-found" */ './router-child/not-found')
]

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

/** router 实例，createRouter 完成后赋值，供 api 等模块使用 */
export let routerInstance = null

/**
 * 异步创建 router：先加载各子路由定义再合并，路由定义本身不进入主包
 * @returns {Promise<Router>}
 */
export function createRouter () {
  return Promise.all(routeModuleLoaders.map(load => load()))
    .then(modules => {
      const routes = modules.reduce((acc, m) => acc.concat(m.default || []), [])
      const router = new Router({ routes })
      routerInstance = router
      return router
    })
}

export default createRouter



// WEBPACK FOOTER //
// ./src/router/index.js